import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AppShell from "../layouts/AppShell";
import { appModules } from "../components/global";
import Switch from "react-switch";
import { GET, POST, PUT, DELETE, loading, alert } from "../components/CustomComponent";

const SocialSecurityModal = ({ show, onHide, editData, onSave }) => {
  const [isActive, setIsActive] = useState(true);

  return (
    <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton className="bg-light border-0">
      <Modal.Title className="fw-bold h5 mb-0">ข้อมูลเงินสมทบ (สปส.)</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className="row g-3">
        <div className="col-md-12">
          <label className="form-label">ชื่อพนักงาน</label>
          <input type="text" className="form-control" defaultValue={editData?.name || ""} disabled={!!editData} />
        </div>
        <div className="col-md-6">
          <label className="form-label">ฐานค่าจ้าง (บาท)</label>
          <input type="number" className="form-control" defaultValue={editData?.wage || ""} max="17500" />
          <div className="form-text text-muted small">คำนวณสูงสุด 17,500 บาท</div>
        </div>
        <div className="col-md-6">
          <label className="form-label">เงินสมทบ 5% (บาท)</label>
          <input type="number" className="form-control" defaultValue={editData?.amount || ""} max="17500" />
          <div className="form-text text-muted small">หักสูงสุด 17500 บาท</div>
        </div>
         <div className="col-12">
          <label className="form-label mb-0 pointer" htmlFor="isActiveOvertime">เปิดใช้งาน (Active)</label><br/>
          <Switch checked={isActive} onChange={setIsActive} onColor="#0c75e6" height={24} width={48} id="isActiveOvertime" />
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer className="bg-light border-0">
      <button type="button" className="btn btn-secondary" onClick={onHide}>ยกเลิก</button>
      <button type="button" className="btn btn-primary" onClick={() => onSave({ isActive })}>บันทึกข้อมูล</button>
    </Modal.Footer>
  </Modal>
  );
};

export default function SocialSecurity() {
  const { title, description } = appModules["social-security"];
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [data, setData] = useState([]);

  const summaryCards = [
    { label: "ยอดรวมนำส่ง (บริษัท+พนักงาน)", value: "฿ 213,000", color: "#0c76e5" },
    { label: "ส่วนของบริษัท (5%)", value: "฿ 106,500", color: "#48bb78" },
    { label: "ส่วนของพนักงาน (5%)", value: "฿ 106,500", color: "#e5a93e" },
  ];

  const handleOpenModal = (data = null) => {
    setEditData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setShowModal(false);
  };

  const GetData = async () => {
    loading(true);
    let body = {};
    let result = await GET("v1/admin/social-security", body);
    if (result?.status) {
      setData(result.data || []);
    }
    loading(false);
  };

  useEffect(() => {
    GetData();
  }, []);

  const CreateUpdate = async (formData) => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let uid = formData?.uid || editData?.uid;
      let body = { ...formData };

      let result = !uid
        ? await POST("v1/admin/social-security", body)
        : await PUT("v1/admin/social-security/" + uid, body);
        
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
        handleCloseModal();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const DeleteData = async (id) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบรายการนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let result = await DELETE("v1/admin/social-security/" + id, null);
      if (result?.status) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
      }
      loading(false);
    }
  };

  return (
    <AppShell title={title} description={description}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div className="d-flex gap-2 filters-mobile-stack">
          <select className="form-select" style={{ width: '200px', borderRadius: '12px' }}>
            <option>งวด: มีนาคม 2026</option>
          </select>
        </div>
        <div className="d-flex gap-2 filters-mobile-stack">
          <button onClick={() => handleOpenModal()} className="btn btn-primary px-4">
            เพิ่มพนักงานสมทบ
          </button>
          <button className="btn btn-outline-primary px-4" style={{ borderRadius: '12px' }}>
            <i className="bi bi-file-earmark-text me-2"></i> สปส. 1-10
          </button>
        </div>
      </div>

      <div className="row g-3 mb-4">
        {summaryCards.map((item) => (
          <div key={item.label} className="col-12 col-md-4">
            <div
              className="h-100 rounded-4 p-4 d-flex flex-column justify-content-center"
              style={{
                background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
                border: "1px solid rgba(18, 125, 255, 0.10)",
                boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
              }}
            >
              <p className="small text-uppercase text-secondary mb-1">{item.label}</p>
              <h2 className="h3 mb-0 fw-bold" style={{ color: item.color }}>{item.value}</h2>
            </div>
          </div>
        ))}
      </div>

      <div
        className="rounded-4 p-3 bg-white"
        style={{
          border: "1px solid rgba(18, 125, 255, 0.10)",
          boxShadow: "0 4px 12px rgba(12, 118, 229, 0.04)",
        }}
      >
        <h5 className="mb-4 fw-semibold text-dark">รายชื่อผู้ประกันตนนำส่ง</h5>
        <div className="table-responsive table-mobile-cards">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-secondary fw-medium rounded-start">ลำดับ</th>
                <th className="text-secondary fw-medium">ชื่อพนักงาน</th>
                <th className="text-secondary fw-medium text-end">ฐานค่าจ้าง</th>
                <th className="text-secondary fw-medium text-end">เงินสมทบ (875 Max)</th>
                <th className="text-secondary fw-medium text-center rounded-end">จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <tr key={i}>
                  <td data-label="ลำดับ">{i}</td>
                  <td data-label="ชื่อพนักงาน"><div className="fw-medium">พนักงาน ทดสอบ {i}</div></td>
                  <td data-label="ฐานค่าจ้าง" className="text-end">17,500.00</td>
                  <td data-label="เงินสมทบ" className="text-end fw-bold">875.00</td>
                  <td data-label="จัดการ" className="text-center"><button onClick={() => handleOpenModal({ name: `พนักงาน ทดสอบ ${i}`, wage: 17500, amount: 875 })} className="btn btn-sm btn-outline-secondary rounded-3" title="แก้ไข"><i className="fa-solid fa-pen" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <SocialSecurityModal show={showModal} onHide={handleCloseModal} editData={editData} onSave={CreateUpdate} />
    </AppShell>
  );
}